import { PrintArea } from '@/types';

export const getPrintAreaSize = (printArea: PrintArea) => printArea.boundary.size;

export const getPrintAreaWidth = (printArea: PrintArea) => getPrintAreaSize(printArea).width;
